import { render, staticRenderFns } from "./noticehome.vue?vue&type=template&id=3fd44df2&scoped=true&"
import script from "./noticehome.vue?vue&type=script&lang=js&"
export * from "./noticehome.vue?vue&type=script&lang=js&"
import style0 from "./noticehome.vue?vue&type=style&index=0&id=3fd44df2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd44df2",
  null
  
)

export default component.exports